/**
 * useMailbox(key) — returns a foundation mailbox address that admins can
 * edit from the admin UI without redeploying.
 *
 * The 4 public mailboxes live as CMS keys:
 *   • mailbox.accounts    (financial / receipts / subscriptions)
 *   • mailbox.sales       (general inquiries / shop / outreach)
 *   • mailbox.volunteers  (volunteer onboarding)
 *   • mailbox.privacy     (privacy / data requests)
 *
 * Admins update them at /admin → Mailboxes. The defaults match what's
 * already in production today, so existing pages keep working until the
 * admin overrides them.
 *
 * Usage:
 *   const { c } = useContentApi();
 *   const accounts = mailbox(c, "accounts");
 *   <a href={`mailto:${accounts}`}>{accounts}</a>
 */

const DEFAULTS = {
    accounts: "accounts@reddogfoundation.org",
    sales: "sales@reddogfoundation.org",
    volunteers: "volunteers@reddogfoundation.org",
    privacy: "privacy@reddogfoundation.org",
};

export const MAILBOX_KEYS = Object.keys(DEFAULTS);

export const MAILBOX_DEFAULTS = DEFAULTS;

export const mailbox = (c, key) => {
    return c(`mailbox.${key}`, DEFAULTS[key] || "");
};
